import React from 'react';
import { Modal, Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';

const WizardWrapper = ({
    open,
    onClose,
    onClick,
    onBack,
    canGoBack,
    sx,
    children,
    disabledButtons
}) => {
    // Ignore clicks on the backdrop, so that a stray click outside the dialog
    // cannot discard the user's input. Escape, Cancel and the X still close.
    const handleModalClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        onClose(event, reason);
    };

    return (
        <Modal open={open} onClose={handleModalClose} onClick={onClick}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    maxWidth: '800px',
                    // Size to the content, but never past the viewport; only
                    // when the screen is too short does the inside scroll.
                    maxHeight: 'calc(100vh - 64px)',
                    overflowY: 'auto',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '15px',
                    pt: 2, pb: 4, pl: 4, pr: 4,
                    transition: 'width 300ms, height 300ms',
                    ...sx
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {canGoBack ? (
                        <IconButton edge="start" color="inherit" onClick={onBack} disabled={disabledButtons} aria-label="back">
                            <ArrowBackIcon size="28" />
                        </IconButton>
                    ) : (
                        <div style={{ flexShrink: 0 }}></div>
                    )}
                    <IconButton edge="end" color="inherit" onClick={onClose} disabled={disabledButtons} aria-label="close">
                        <CloseIcon size="28" />
                    </IconButton>
                </Box>
                {children}
            </Box>
        </Modal>
    );
};

export default WizardWrapper;
